module.exports = __webpack_public_path__ + "b38fc4ca6f52ad4fa08aceb371ca221c.mp3";